
import {Box,Divider,useToast, Badge, Text} from "@chakra-ui/react";
import { useState,useEffect } from "react";
import {getOsobePosjednikKnjiga} from "../../util/apiOsoba";
import {getKnjigeShort} from "../../util/apiKnjiga";
import { getPasmineKlijenta } from "../../util/apiPasmina";

export default function RegistarFilterInfo({size='xs',leftsidewidth='25%',rightsidewidth='75%', _posjednici=[],_knjige=[],_stanjenadan="",_napustilagospodarstvo=false,
_doltipperiod={},_odltipperiod={},_tovdani={},_lokacije=[],_tovdatumi={},_spol="", _roddatumi={},_pasmine=[]}) {
    const [err,setErr]=useState("");
    const [posjednici,setPosjednici]=useState([])
    const [pasmine,setPasmine]=useState([]);
    const [knjige,setKnjige]=useState([])
    const toast=useToast();

    useEffect(() => {
        const fetchPasmine=async ()=>{
            try {
                const _res=await getPasmineKlijenta();
                if (_res.status===200) {
                  setPasmine(_res.res);
                } else {
                  throw new Error(_res.message);
                }
              } catch (error) {
                setErr(error.message);
              }
        }
      const fetchPosjednici=async()=>{
        try {
            const _res=await getOsobePosjednikKnjiga({orderbycolumn:"naziv",orderby:"asc"});
            if (_res.status===200) {
              setPosjednici(_res.res);
            } else {
              throw new Error(_res.message);
            }
          } catch (error) {
            setErr(error.message);
          }
      }
      const fetchKnjige=async()=>{
        try {
            const _res=await getKnjigeShort();
            if (_res.status===200) {
              setKnjige(_res.res);
            } else {
              throw new Error(_res.message);
            }
          } catch (error) {
            setErr(error.message);
          }
      }
    
      if (_posjednici.length>0 ) {
        fetchPosjednici();
      }
      if (_knjige.length>0) {
        fetchKnjige();
      }
      if (_pasmine.length>0) {
        fetchPasmine();
      }
    }, [])
    
    const getPosjednici=()=>{
        
        return (
            <>
            {posjednici.map((item,index)=>{
            if (_posjednici.includes(item.id.toString())) {
                return (<Box key={index} mr={'8px'} mb={'2px'}><Badge>{item.naziv}</Badge></Box>)    
            } else {
                return null;
            }
            
        })}
            </>
        )
    }
    const getPasmine=()=>{
        
        return (
            <>
            {pasmine.map((item,index)=>{
            if (_pasmine.includes(item.sifra)) {
                return (<Box key={index} mr={'8px'} mb={'2px'}><Badge>{item.pasmina}</Badge></Box>)    
            } else {
                return null;
            }
            
        })}
            </>
        )
    }
    
    const getKnjige=()=>{
        return (
            <>
            {knjige.map((item,index)=>{
                if (_knjige.includes(item.id.toString())) {
                    return (<Box key={index} mr={'8px'} mb={'2px'}><Badge>{item.naziv}</Badge></Box>)    
                }
                
            })}
            </>
        )
    }
    const Posjednici=()=>{
        if (_posjednici.length>0 && err==="" && posjednici.length>0) {
            return (
                <>
                <Box mb={'0.2rem'} display={'flex'} flexDir={'row'} alignItems={'center'} justifyContent={'center'}>
                        
                        <Box w={leftsidewidth} m={'2px'} justifyContent={'center'} fontSize={size} fontWeight={'semibold'}>
                            Posjednici
                        </Box>
                        
                        <Box w={rightsidewidth} fontSize={size} display={'flex'} flexDir={'row'} flexWrap={'wrap'} m={'2px'} p={'2px'} >
                            {getPosjednici()}
                        </Box>
                    </Box>
                    <Divider/>
                </>
            )
        }
        
    }
    const Knjige=()=>{
        if (_knjige.length>0 && err==="" && knjige.length>0) {
            return (
                <>
            <Box mb={'0.2rem'} display={'flex'} flexDir={'row'} alignItems={'center'} justifyContent={'center'}>
                    
                    <Box w={leftsidewidth} m={'2px'} justifyContent={'center'} fontSize={size} fontWeight={'semibold'}>
                        Knjige
                    </Box>
                    
                    <Box w={rightsidewidth} fontSize={size} display={'flex'} flexDir={'row'} flexWrap={'wrap'} m={'2px'} p={'2px'} >
                        {getKnjige()}
                    </Box>
                </Box>
                <Divider/>
                </>
            )    
        }
        
    }

    const StanjeNaDan=()=>{
        if (_stanjenadan!=="") {
            return (
                <>
            <Box mb={'0.2rem'} display={'flex'} flexDir={'row'} alignItems={'center'} justifyContent={'center'}>
                    
                    <Box w={leftsidewidth} m={'2px'} justifyContent={'center'} fontSize={size} fontWeight={'semibold'}>
                        Stanje na dan
                    </Box>
                    <Box w={rightsidewidth} fontSize={size} display={'flex'} flexDir={'row'} flexWrap={'wrap'} m={'2px'} p={'2px'} >
                        <Badge>{new Date(_stanjenadan).toLocaleDateString('hr-HR')}</Badge>                 
                    </Box>
                </Box>
            <Divider/>
            </>
            )    
        }
        
    }

    const NapustilaGospodarstvo=()=>{
        if (_napustilagospodarstvo) {
            return (
                <>
                <Box mb={'0.2rem'} display={'flex'} flexDir={'row'} alignItems={'center'} justifyContent={'center'}>
                    
                    <Box w={leftsidewidth} m={'2px'} fontSize={size} fontWeight={'semibold'}>
                        Napustila gospodarstvo
                    </Box>
                    <Box w={rightsidewidth} fontSize={size} display={'flex'} flexDir={'row'} flexWrap={'wrap'} m={'2px'} p={'2px'} >
                        <Badge>DA</Badge>
                    </Box>
                </Box>
                <Divider/>
                </>
            )    
        }
        
    }
    const Lokacije=()=>{
        if (_lokacije.length>0) {
            return (
                <>
                <Box mb={'0.2rem'} display={'flex'} flexDir={'row'} alignItems={'center'} justifyContent={'center'}>
                    
                    <Box w={leftsidewidth} m={'2px'} fontSize={size} fontWeight={'semibold'}>
                        Lokacije
                    </Box>
                    <Box w={rightsidewidth} fontSize={size} display={'flex'} flexDir={'row'} flexWrap={'wrap'} m={'2px'} p={'2px'} >
                        <Badge>Ujključen filter po lokacijama</Badge>
                    </Box>
                </Box>
                <Divider/>
                </>
            )    
        }
        
    }

    const DolasciPoTipuIPeriodu=()=>{
        if (Object.getOwnPropertyNames(_doltipperiod).length!==0) {
            return (
                <>
                <Box mb={'0.2rem'} display={'flex'} flexDir={'row'} alignItems={'center'} justifyContent={'center'}>
                    
                    <Box w={leftsidewidth} m={'2px'} justifyContent={'center'} fontSize={size} fontWeight={'bold'}>
                        Dolasci
                    </Box>
                    {_doltipperiod.filterbymigracije===false?
                    <Box w={rightsidewidth} fontSize={size} fm={'2px'} p={'2px'} >
                        <Box display={'flex'} flexDir={'row'}>
                            <Box w={'50%'} fontSize={size}>
                                Od datuma
                            </Box>
                            <Box w={'50%'} fontSize={size}>
                                Do datuma
                            </Box>
                        </Box>
                        <Box display={'flex'} flexDir={'row'}>
                            <Box w={'50%'}>
                                <Badge>{new Date(_doltipperiod.datod).toLocaleDateString('hr-HR')}</Badge>
                            </Box>
                            <Box w={'50%'}>
                                <Badge>{new Date(_doltipperiod.datdo).toLocaleDateString('hr-HR')}</Badge>
                            </Box>
                        </Box>
                        <Box display={'flex'} flexDir={'row'}>
                            <Box w={'33%'} fontSize={size}>
                                Kupnja
                            </Box>
                            <Box w={'33%'} fontSize={size}>
                                Uvoz
                            </Box>
                            <Box w={'34%'} fontSize={size}>
                                Telenje
                            </Box>
                        </Box>
                        <Box display={'flex'} flexDir={'row'}>
                            <Box w={'33%'}>
                                <Badge>{_doltipperiod.dkup?"DA":"NE"}</Badge>
                            </Box>
                            <Box w={'33%'}>
                                <Badge>{_doltipperiod.duvoz?"DA":"NE"}</Badge>
                            </Box>
                            <Box w={'34%'}>
                                <Badge>{_doltipperiod.dtelj?"DA":"NE"}</Badge>
                            </Box>
                        </Box>
                        {_doltipperiod.prijasnji_posjednik_knjiga!==-1?
                        <Box display={'flex'} flexDir={'row'}>
                            <Box w={'100%'}>
                                <Badge>{_doltipperiod.prijasnji_posjednik_knjiga_naziv}</Badge>
                            </Box>
                        </Box>
                        :null}
                    </Box>:
                        <Box w={rightsidewidth} fontSize={size} display={'flex'} flexDir={'row'} flexWrap={'wrap'} m={'2px'} p={'2px'} >
                        <Badge>Odabrane migracije</Badge>
                    </Box>    }
                </Box>
                <Divider/>
                </>
            )
        }
        
    }
    const Pasmine=()=>{
        if (_pasmine.length>0 && err==="" && pasmine.length>0) {
            return (
                <>
                <Box mb={'0.2rem'} display={'flex'} flexDir={'row'} alignItems={'center'} justifyContent={'center'}>
                        
                        <Box w={leftsidewidth} m={'2px'} justifyContent={'center'} fontSize={size} fontWeight={'semibold'}>
                            Pasmine
                        </Box>
                        
                        <Box w={rightsidewidth} fontSize={size} display={'flex'} flexDir={'row'} flexWrap={'wrap'} m={'2px'} p={'2px'} >
                            {getPasmine()}
                        </Box>
                    </Box>
                    <Divider/>
                </>
            )
        }
        
    }

    const showErr=()=>{
        if (err!=="") {
          setErr("");
          return(
          toast({
            title:"Greška kod dohvata podataka.",
            status:"error",
            description:err,
            isClosable:true,
            duration:2000,
            position:"top-right",
        }));
        
        }
      }
      

    const OdlasciPoTipuIPeriodu=()=>{
        if (Object.getOwnPropertyNames(_odltipperiod).length!==0) {
            return (
                <>
                <Box mb={'0.2rem'} display={'flex'} flexDir={'row'} alignItems={'center'} justifyContent={'center'}>
                    
                    <Box w={leftsidewidth} m={'2px'} justifyContent={'center'} fontSize={size} fontWeight={'bold'}>
                        Odlasci
                    </Box>
                    {_odltipperiod.filterbymigracije===false?
                    <Box w={rightsidewidth} fontSize={size} fm={'2px'} p={'2px'} >
                        <Box display={'flex'} flexDir={'row'}>
                            <Box w={'50%'} fontSize={size}>
                                Od datuma
                            </Box>
                            <Box w={'50%'} fontSize={size}>
                                Do datuma
                            </Box>
                        </Box>
                        <Box display={'flex'} flexDir={'row'}>
                            <Box w={'50%'}>
                                <Badge>{new Date(_odltipperiod.datod).toLocaleDateString('hr-HR')}</Badge>
                            </Box>
                            <Box w={'50%'}>
                            <Badge>{new Date(_odltipperiod.datdo).toLocaleDateString('hr-HR')}</Badge>
                            </Box>
                        </Box>
                        <Box display={'flex'} flexDir={'row'}>
                            <Box w={'33%'} fontSize={size}>
                                Prodaja
                            </Box>
                            <Box w={'33%'} fontSize={size}>
                                Izvoz
                            </Box>
                            <Box w={'34%'} fontSize={size}>
                                Int. migracija
                            </Box>
                        </Box>
                        <Box display={'flex'} flexDir={'row'}>
                            <Box w={'33%'}>
                                <Badge>{_odltipperiod.oprod?"DA":"NE"}</Badge>
                            </Box>
                            <Box w={'33%'}>
                            <Badge>{_odltipperiod.oizvz?"DA":"NE"}</Badge>
                            </Box>
                            <Box w={'34%'}>
                            <Badge>{_odltipperiod.omik?"DA":"NE"}</Badge>
                            </Box>
                        </Box>
                        <Box display={'flex'} flexDir={'row'}>
                            <Box w={'33%'} fontSize={size}>
                                Krađa/izgub.
                            </Box>
                            <Box w={'33%'} fontSize={size}>
                                Klaonica
                            </Box>
                            <Box w={'34%'} fontSize={size}>
                                Uginulo
                            </Box>
                        </Box>
                        <Box display={'flex'} flexDir={'row'}>
                            <Box w={'33%'}>
                            <Badge>{_odltipperiod.oizgb?"DA":"NE"}</Badge>
                            </Box>
                            <Box w={'33%'}>
                            <Badge>{_odltipperiod.okla?"DA":"NE"}</Badge>
                            </Box>
                            <Box w={'34%'}>
                                <Badge>{_odltipperiod.ougin?"DA":"NE"}</Badge>
                            </Box>
                        </Box>
                        {_odltipperiod.novi_posjednik_knjiga!==-1?
                        <Box display={'flex'} flexDir={'row'}>
                            <Box w={'100%'}>
                                <Badge>{_odltipperiod.novi_posjednik_knjiga_naziv}</Badge>
                            </Box>
                        </Box>
                        :null}
                    </Box>:
                    <Box w={rightsidewidth} fontSize={size} display={'flex'} flexDir={'row'} flexWrap={'wrap'} m={'2px'} p={'2px'} >
                        <Badge>Odabrane migracije</Badge>
                    </Box>
                    }
                </Box>
                <Divider/>
                </>
            )
        }
        
    }
    const TovDani=()=>{
        if (Object.getOwnPropertyNames(_tovdani).length!==0) {
            return (
                <>
                <Box mb={'0.2rem'} display={'flex'} flexDir={'row'} alignItems={'center'} justifyContent={'center'}>
                    
                    <Box w={leftsidewidth} m={'2px'} justifyContent={'center'} fontSize={size} fontWeight={'bold'}>
                        Tov (dani)
                    </Box>
                    <Box w={rightsidewidth} fontSize={size} fm={'2px'} p={'2px'} >
                        <Box display={'flex'} flexDir={'row'}>
                            <Box w={'50%'} fontSize={size}>
                                Dani od
                            </Box>
                            <Box w={'50%'} fontSize={size}>
                                Dani do
                            </Box>
                        </Box>
                        <Box display={'flex'} flexDir={'row'}>
                            <Box w={'50%'}>
                                <Badge>{_tovdani.min}</Badge>
                            </Box>
                            <Box w={'50%'}>
                                <Badge>{_tovdani.max}</Badge>
                            </Box>
                        </Box>
                        
                        
                    </Box>
                </Box>
                <Divider/>
                </>
            )
        }
        
    }
    const Spol=()=>{
        if (_spol!=="") {
            return (
                <>
                    <Box mb={'0.2rem'} display={'flex'} flexDir={'row'} alignItems={'center'} justifyContent={'center'}>
                        <Box w={leftsidewidth} m={'2px'} justifyContent={'center'} fontSize={size} fontWeight={'bold'}>
                            Spol
                        </Box>
                        <Box w={rightsidewidth} fontSize={size} fm={'2px'} p={'2px'} >
                            <Badge>{_spol==="f"?'ŽENSKO':'MUŠKO'}</Badge>
                        </Box>
                    </Box>  
                </>
            )
        }
    }
    const TovDatumi=()=>{
        if (Object.getOwnPropertyNames(_tovdatumi).length!==0) {
            return (
                <>
                <Box mb={'0.2rem'} display={'flex'} flexDir={'row'} alignItems={'center'} justifyContent={'center'}>
                    
                    <Box w={leftsidewidth} m={'2px'} justifyContent={'center'} fontSize={size} fontWeight={'bold'}>
                        Tov (datumi)
                    </Box>
                    <Box w={rightsidewidth} fontSize={size} fm={'2px'} p={'2px'} >
                        <Box display={'flex'} flexDir={'row'}>
                            <Box w={'50%'} fontSize={size}>
                                Datum od
                            </Box>
                            <Box w={'50%'} fontSize={size}>
                                Datum do
                            </Box>
                        </Box>
                        <Box display={'flex'} flexDir={'row'}>
                            <Box w={'50%'}>
                                <Badge>{new Date(_tovdatumi.datod).toLocaleDateString('hr-HR')}</Badge>
                            </Box>
                            <Box w={'50%'}>
                                <Badge>{new Date(_tovdatumi.datdo).toLocaleDateString('hr-HR')}</Badge>
                            </Box>
                        </Box>
                        
                        
                    </Box>
                </Box>
                <Divider/>
                </>
            )
        }
    }
    const RodDatumi=()=>{
        if (Object.getOwnPropertyNames(_roddatumi).length!==0) {
            return (
                <>
                <Box mb={'0.2rem'} display={'flex'} flexDir={'row'} alignItems={'center'} justifyContent={'center'}>
                    
                    <Box w={leftsidewidth} m={'2px'} justifyContent={'center'} fontSize={size} fontWeight={'bold'}>
                        Datum rođenja
                    </Box>
                    <Box w={rightsidewidth} fontSize={size} fm={'2px'} p={'2px'} >
                        <Box display={'flex'} flexDir={'row'}>
                            <Box w={'50%'} fontSize={size}>
                                Datum od
                            </Box>
                            <Box w={'50%'} fontSize={size}>
                                Datum do
                            </Box>
                        </Box>
                        <Box display={'flex'} flexDir={'row'}>
                            <Box w={'50%'}>
                                <Badge>{new Date(_roddatumi.datod).toLocaleDateString('hr-HR')}</Badge>
                            </Box>
                            <Box w={'50%'}>
                                <Badge>{new Date(_roddatumi.datdo).toLocaleDateString('hr-HR')}</Badge>
                            </Box>
                        </Box>
                        
                        
                    </Box>
                </Box>
                <Divider/>
                </>
            )
        }
    }
    const retDisplay=()=>{
        if (Object.getOwnPropertyNames(_tovdani).length===0 && Object.getOwnPropertyNames(_tovdatumi).length===0 && Object.getOwnPropertyNames(_doltipperiod).length===0 && Object.getOwnPropertyNames(_odltipperiod).length===0 &&
        _knjige.length===0 && _lokacije.length===0 && _posjednici.length===0 && _napustilagospodarstvo===false && _stanjenadan==="") {
           return ( <>
                <Text fontSize={'lg'} fontWeight={'normal'}>Nema aktivnih filtera</Text>
            </>)
        } else {
            return (
                <>
                    {Posjednici()}
                    {Knjige()}
                    {StanjeNaDan()}
                    {NapustilaGospodarstvo()}
                    {DolasciPoTipuIPeriodu()}
                    {OdlasciPoTipuIPeriodu()}
                    {TovDani()}
                    {TovDatumi()}
                    {RodDatumi()}
                    {Lokacije()}
                    {Spol()}
                    {Pasmine()}
                    {showErr()}
                </>
            )
        }
    }
  return (
    
            <Box>
                {retDisplay()}
            </Box>
        
  )
}
